import { render, staticRenderFns } from "./TermsHeader.vue?vue&type=template&id=255bbe1c&"
import script from "./TermsHeader.vue?vue&type=script&lang=js&"
export * from "./TermsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports